import { PaletteOptions } from '@mui/material/styles';

/**
 * Kaive brand color palette
 *
 * Based on the official brand manual:
 * - Pantone 533 C: #2C2B50 (Dark navy)
 * - Pantone 7665 C: #563968 (Deep purple)
 * - Pantone 522 C: #C29CC8 (Medium lilac)
 * - Pantone 665 C: #CDB9DB (Light lilac)
 */
export const palette: PaletteOptions = {
  primary: {
    main: '#563968',
    light: '#C29CC8',
    dark: '#2C2B50',
    contrastText: '#ffffff',
  },

  secondary: {
    main: '#C29CC8',
    light: '#CDB9DB',
    dark: '#563968',
    contrastText: '#2C2B50',
  },

  error: {
    main: '#d32f2f',
    light: '#ef5350',
    dark: '#c62828',
    contrastText: '#ffffff',
  },

  warning: {
    main: '#ed6c02',
    light: '#ff9800',
    dark: '#e65100',
    contrastText: '#ffffff',
  },

  info: {
    main: '#0288d1',
    light: '#03a9f4',
    dark: '#01579b',
    contrastText: '#ffffff',
  },

  success: {
    main: '#2e7d32',
    light: '#4caf50',
    dark: '#1b5e20',
    contrastText: '#ffffff',
  },

  background: {
    default: '#f8f6fa',
    paper: '#ffffff',
  },

  text: {
    primary: '#2C2B50',
    secondary: '#666666',
    disabled: '#9e9e9e',
  },

  divider: 'rgba(0, 0, 0, 0.12)',

  action: {
    active: 'rgba(0, 0, 0, 0.54)',
    hover: 'rgba(0, 0, 0, 0.04)',
    selected: 'rgba(0, 0, 0, 0.08)',
    disabled: 'rgba(0, 0, 0, 0.26)',
    disabledBackground: 'rgba(0, 0, 0, 0.12)',
  },
};
